const article1 = {
  id: 1,
  passage: `TechCorp Acquires Innovate Solutions to Expand AI Capabilities
Source: Business Weekly
Date: April 15, 2025

TechCorp, a leading technology firm, has announced its <mark>acquisition</mark> of Innovate Solutions, a company specializing in artificial intelligence and automation. The deal, valued at $850 million, is expected to <mark>strengthen</mark> TechCorp's AI-driven product line and expand its <mark>presence</mark> in global markets.

According to company officials, the <mark>acquisition</mark> will allow TechCorp to <mark>integrate</mark> Innovate Solutions' cutting-edge machine learning algorithms into its existing platforms. "This strategic move positions us at the <mark>forefront</mark> of AI innovation," said TechCorp CEO Jonathan Pierce. "By combining our expertise, we aim to deliver smarter and more efficient solutions for businesses worldwide."

Founded in 2008, Innovate Solutions has developed AI applications used in industries such as finance, healthcare, and logistics. Its flagship product, InnoBot, an AI-powered virtual assistant, has gained widespread adoption among enterprise clients. TechCorp officials have confirmed that the Innovate Solutions brand will remain <mark>intact</mark>, with its headquarters continuing operations in San Francisco.

The acquisition follows TechCorp's recent expansion efforts, including a $300 million investment in cloud computing infrastructure. Industry analysts predict that this <mark>latest</mark> move will enhance TechCorp's ability to compete with major AI companies.

More details about the acquisition will be revealed at the upcoming TechCorp Annual Conference, scheduled for May 20, 2025, in New York City.`,

  translation: `테크코프, AI 역량 확대를 위해 이노베이트 솔루션즈 인수
출처: 비즈니스 위클리
날짜: 2025년 4월 15일

선도적인 기술 기업인 테크코프가 인공지능과 자동화 분야의 전문 기업인 이노베이트 솔루션즈의 인수를 발표했습니다. 8억 5천만 달러 규모의 이번 거래는 테크코프의 AI 기반 제품 라인을 강화하고 글로벌 시장에서의 입지를 확대할 것으로 예상됩니다.

According to company officials, the acquisition will allow TechCorp to integrate Innovate Solutions' cutting-edge machine learning algorithms into its existing platforms. "This strategic move positions us at the forefront of AI innovation," said TechCorp CEO Jonathan Pierce. "By combining our expertise, we aim to deliver smarter and more efficient solutions for businesses worldwide."

Founded in 2008, Innovate Solutions has developed AI applications used in industries such as finance, healthcare, and logistics. Its flagship product, InnoBot, an AI-powered virtual assistant, has gained widespread adoption among enterprise clients. TechCorp officials have confirmed that the Innovate Solutions brand will remain intact, with its headquarters continuing operations in San Francisco.

The acquisition follows TechCorp's recent expansion efforts, including a $300 million investment in cloud computing infrastructure. Industry analysts predict that this latest move will enhance TechCorp's ability to compete with major AI companies.

More details about the acquisition will be revealed at the upcoming TechCorp Annual Conference, scheduled for May 20, 2025, in New York City.`,
  koreanNouns: `TechCorp Acquires Innovate Solutions to Expand AI Capabilities
Source: Business Weekly
Date: April 15, 2025

TechCorp, a leading technology firm, has announced its <mark>인수</mark> of Innovate Solutions, a company specializing in artificial intelligence and automation. The deal, valued at $850 million, is expected to <mark>강화하다</mark> TechCorp's AI-driven product line and expand its <mark>입지</mark> in global markets.

According to company officials, the <mark>인수</mark> will allow TechCorp to <mark>통합하다</mark> Innovate Solutions' cutting-edge machine learning algorithms into its existing platforms. "This strategic move positions us at the <mark>최전선</mark> of AI innovation," said TechCorp CEO Jonathan Pierce. "By combining our expertise, we aim to deliver smarter and more efficient solutions for businesses worldwide."

Founded in 2008, Innovate Solutions has developed AI applications used in industries such as finance, healthcare, and logistics. Its flagship product, InnoBot, an AI-powered virtual assistant, has gained widespread adoption among enterprise clients. TechCorp officials have confirmed that the Innovate Solutions brand will remain <mark>온전한</mark>, with its headquarters continuing operations in San Francisco.

The acquisition follows TechCorp's recent expansion efforts, including a $300 million investment in cloud computing infrastructure. Industry analysts predict that this <mark>최신의</mark> move will enhance TechCorp's ability to compete with major AI companies.

More details about the acquisition will be revealed at the upcoming TechCorp Annual Conference, scheduled for May 20, 2025, in New York City.`,

  wordPairs: {
    acquisition: "인수",
    strengthen: "강화하다",
    presence: "입지",
    integrate: "통합하다",
    forefront: "최전선",
    intact: "온전한",
    latest: "최신의",
  },

  questions: [],
};

const article2 = {
  id: 2,
  passage: `SmartTech Unveils Next-Generation Smartwatch, VisionX Pro
Source: Business Daily News
Date: June 5, 2025

SmartTech, a leading innovator in wearable technology, has officially announced the launch of its latest smartwatch, the VisionX Pro. The device, which features advanced health tracking and AI-driven functionality, is expected to <mark>redefine</mark> the smart wearables market.

The VisionX Pro boasts a high-resolution AMOLED display, an extended battery life of up to 10 days, and real-time health monitoring capabilities, including ECG tracking and oxygen saturation measurement. The smartwatch is also equipped with voice-activated AI assistance, enabling users to manage schedules, send messages, and control smart home devices <mark>effortlessly</mark>.

"Our goal is to provide a <mark>seamless</mark> blend of technology and daily life," said Michael Grant, CEO of SmartTech. "The VisionX Pro is not just a smartwatch; it's an intelligent companion that enhances productivity and wellness."

The device will be available for pre-order starting June 10, 2025, with an <mark>official retail release</mark> on June 25, 2025. Customers who pre-order will receive an <mark>exclusive</mark> wireless charging dock and a three-month premium subscription to SmartTech Health+.

Industry analysts anticipate that the VisionX Pro will strengthen SmartTech's position in the competitive wearables market, particularly against established brands.`,

  translation: `스마트테크, 차세대 스마트워치 비전X 프로 공개
출처: 비즈니스 데일리 뉴스
날짜: 2025년 6월 5일

웨어러블 기술 분야의 선도적 혁신기업인 스마트테크가 최신 스마트워치인 비전X 프로의 출시를 공식 발표했습니다. 고급 건강 추적 기능과 AI 기반 기능을 갖춘 이 기기는 스마트 웨어러블 시장에 새로운 기준을 제시할 것으로 예상됩니다.

비전X 프로는 고해상도 AMOLED 디스플레이, 최대 10일의 연장된 배터리 수명, 심전도 추적과 산소포화도 측정을 포함한 실시간 건강 모니터링 기능을 자랑합니다. 이 스마트워치는 또한 음성 활성화 AI 지원 기능을 탑재하여 사용자가 일정 관리, 메시지 전송, 스마트홈 기기 제어를 손쉽게 할 수 있습니다.

"Our goal is to provide a seamless blend of technology and daily life," said Michael Grant, CEO of SmartTech. "The VisionX Pro is not just a smartwatch; it's an intelligent companion that enhances productivity and wellness."

The device will be available for pre-order starting June 10, 2025, with an official retail release on June 25, 2025. Customers who pre-order will receive an exclusive wireless charging dock and a three-month premium subscription to SmartTech Health+.

Industry analysts anticipate that the VisionX Pro will strengthen SmartTech's position in the competitive wearables market, particularly against established brands.`,
  koreanNouns: `SmartTech Unveils Next-Generation Smartwatch, VisionX Pro
Source: Business Daily News
Date: June 5, 2025

SmartTech, a leading innovator in wearable technology, has officially announced the launch of its latest smartwatch, the VisionX Pro. The device, which features advanced health tracking and AI-driven functionality, is expected to <mark>새로운 기준을 제시하다</mark> the smart wearables market.

The VisionX Pro boasts a high-resolution AMOLED display, an extended battery life of up to 10 days, and real-time health monitoring capabilities, including ECG tracking and oxygen saturation measurement. The smartwatch is also equipped with voice-activated AI assistance, enabling users to manage schedules, send messages, and control smart home devices <mark>손쉽게</mark>.

"Our goal is to provide a <mark>원활한</mark> blend of technology and daily life," said Michael Grant, CEO of SmartTech. "The VisionX Pro is not just a smartwatch; it's an intelligent companion that enhances productivity and wellness."

The device will be available for pre-order starting June 10, 2025, with an <mark>공식 소매 출시</mark> on June 25, 2025. Customers who pre-order will receive an <mark>독점적인</mark> wireless charging dock and a three-month premium subscription to SmartTech Health+.

Industry analysts anticipate that the VisionX Pro will strengthen SmartTech's position in the competitive wearables market, particularly against established brands.`,

  wordPairs: {
    redefine: "새로운 기준을 제시하다",
    effortlessly: "손쉽게",
    seamless: "원활한",
    "official retail release": "공식 소매 출시",
    exclusive: "독점적인",
  },

  questions: [],
};

const article3 = {
  id: 3,
  passage: `GreenTech Solutions Launches Initiative to Reduce Carbon Footprint
Source: Sustainable Business News
Date: October 20, 2025

GreenTech Solutions, a global leader in <mark>renewable</mark> energy, has announced a new initiative to reduce its <mark>carbon footprint</mark> by 50% over the next decade. The initiative, named "GreenFuture 2035," focuses on enhancing sustainable production processes and investing in clean energy sources.

As part of this commitment, GreenTech Solutions will transition its manufacturing facilities to 100% solar and wind energy by 2028. Additionally, the company plans to introduce a new line of fully recyclable consumer electronics by 2026.

"We believe sustainability should be at the core of technological innovation," said Eleanor Hughes, CEO of GreenTech Solutions. "Through our GreenFuture 2035 initiative, we aim to lead the industry toward a cleaner and more responsible future."

Key Initiative Goals:
• Reduce greenhouse gas emissions by 50% by 2035
• Expand research on <mark>biodegradable</mark> electronic materials
• Partner with non-profits to promote environmental awareness

Industry analysts predict that this initiative will strengthen GreenTech's position as an industry leader in eco-friendly technology while encouraging other companies to adopt similar strategies.`,

  translation: `그린테크 솔루션즈, 탄소배출량 감축 계획 발표
출처: 지속가능 비즈니스 뉴스
날짜: 2025년 10월 20일

재생에너지 분야의 세계적 선도기업인 그린테크 솔루션즈가 향후 10년간 자사의 탄소배출량을 50% 감축하는 새로운 계획을 발표했습니다. "그린퓨처 2035"로 명명된 이 계획은 지속가능한 생산 공정 개선과 청정에너지원 투자에 중점을 두고 있습니다.

이러한 약속의 일환으로, 그린테크 솔루션즈는 2028년까지 제조시설을 100% 태양광과 풍력 에너지로 전환할 예정입니다. 또한 2026년까지 완전 재활용 가능한 새로운 소비자 전자제품 라인을 도입할 계획입니다.

그린테크 솔루션즈의 CEO 엘리너 휴즈는 "지속가능성이 기술 혁신의 핵심이 되어야 한다고 믿습니다"라며, "그린퓨처 2035 계획을 통해 우리는 산업계를 더 깨끗하고 책임감 있는 미래로 이끌고자 합니다"라고 말했습니다.

주요 계획 목표:
• 2035년까지 온실가스 배출량 50% 감축
• 생분해성 전자 소재 연구 확대
• 환경 인식 제고를 위한 비영리단체와의 협력

업계 분석가들은 이 계획이 친환경 기술 분야에서 그린테크의 업계 선도적 위치를 강화하는 동시에 다른 기업들도 유사한 전략을 채택하도록 장려할 것으로 예측하고 있습니다.`,

  koreanNouns: `GreenTech Solutions Launches Initiative to Reduce Carbon Footprint
Source: Sustainable Business News
Date: October 20, 2025

GreenTech Solutions, a global leader in <mark>재생 가능한</mark> energy, has announced a new initiative to reduce its <mark>탄소 배출량</mark> by 50% over the next decade. The initiative, named "GreenFuture 2035," focuses on enhancing sustainable production processes and investing in clean energy sources.

As part of this commitment, GreenTech Solutions will transition its manufacturing facilities to 100% solar and wind energy by 2028. Additionally, the company plans to introduce a new line of fully recyclable consumer electronics by 2026.

"We believe sustainability should be at the core of technological innovation," said Eleanor Hughes, CEO of GreenTech Solutions. "Through our GreenFuture 2035 initiative, we aim to lead the industry toward a cleaner and more responsible future."

Key Initiative Goals:
• Reduce greenhouse gas emissions by 50% by 2035
• Expand research on <mark>생분해성의</mark> electronic materials
• Partner with non-profits to promote environmental awareness

Industry analysts predict that this initiative will strengthen GreenTech's position as an industry leader in eco-friendly technology while encouraging other companies to adopt similar strategies.`,

  wordPairs: {
    renewable: "재생 가능한",
    "carbon footprint": "탄소 배출량",
    biodegradable: "생분해성의",
  },

  questions: [],
};

const article4 = {
  id: 4,
  passage: `MedTech Innovations Unveils Breakthrough in Cancer <mark>Detection</mark>
Source: Medical Science Today
Date: November 5, 2025

MedTech Innovations, a leading biotechnology firm, has announced a major breakthrough in cancer detection. The company's newly developed AI-driven diagnostic tool, BioScan-X, can detect early-stage cancer with 98% accuracy, significantly improving early diagnosis rates.

The BioScan-X system, developed <mark>in collaboration with</mark> Harvard Medical Research Institute, utilizes deep learning algorithms to analyze blood samples in real-time. This innovation is expected to reduce diagnostic time from weeks to mere hours.

"This advancement represents a significant step forward in the fight against cancer," said Dr. Emily Chen, Chief Medical Officer at MedTech Innovations. "Our goal is to make early detection more accessible, ultimately saving more lives."

Future Development Plans:
• Obtain FDA approval by mid-2026
• Expand clinical trials across Europe and North America
• Partner with major hospitals for real-world testing

Medical professionals and researchers have hailed BioScan-X as a game-changer, predicting that it could become the standard for early cancer detection worldwide.`,

  translation: `메드테크 이노베이션스, 암 진단 분야의 획기적 발전 공개
출처: 메디컬 사이언스 투데이
날짜: 2025년 11월 5일

선도적인 생명공학 기업인 메드테크 이노베이션스가 암 진단 분야의 중대한 돌파구를 발표했습니다. 회사가 새롭게 개발한 AI 기반 진단 도구인 바이오스캔-X는 98%의 정확도로 초기 암을 감지할 수 있어, 조기 진단율을 크게 향상시킬 것으로 기대됩니다.

하버드 의학연구소와 협력하여 개발된 바이오스캔-X 시스템은 딥러닝 알고리즘을 활용하여 실시간으로 혈액 샘플을 분석합니다. 이 혁신은 진단 시간을 몇 주에서 단 몇 시간으로 단축할 것으로 예상됩니다.

메드테크 이노베이션스의 최고의료책임자인 에밀리 첸 박사는 "이번 발전은 암과의 싸움에서 중요한 진전을 의미합니다"라며, "우리의 목표는 조기 진단을 더욱 접근하기 쉽게 만들어 궁극적으로 더 많은 생명을 구하는 것입니다"라고 말했습니다.

향후 개발 계획:
• 2026년 중반까지 FDA 승인 획득
• 유럽과 북미 전역으로 임상시험 확대
• 실제 테스트를 위한 주요 병원들과의 협력

의료 전문가들과 연구진들은 바이오스캔-X를 게임체인저로 평가하며, 전 세계적으로 조기 암 진단의 표준이 될 수 있을 것으로 예측하고 있습니다.`,

  koreanNouns: `MedTech Innovations Unveils Breakthrough in Cancer <mark>진단</mark>
Source: Medical Science Today
Date: November 5, 2025

MedTech Innovations, a leading biotechnology firm, has announced a major breakthrough in cancer detection. The company's newly developed AI-driven diagnostic tool, BioScan-X, can detect early-stage cancer with 98% accuracy, significantly improving early diagnosis rates.

The BioScan-X system, developed <mark>협력하여</mark> Harvard Medical Research Institute, utilizes deep learning algorithms to analyze blood samples in real-time. This innovation is expected to reduce diagnostic time from weeks to mere hours.

"This advancement represents a significant step forward in the fight against cancer," said Dr. Emily Chen, Chief Medical Officer at MedTech Innovations. "Our goal is to make early detection more accessible, ultimately saving more lives."

Future Development Plans:
• Obtain FDA approval by mid-2026
• Expand clinical trials across Europe and North America
• Partner with major hospitals for real-world testing

Medical professionals and researchers have hailed BioScan-X as a game-changer, predicting that it could become the standard for early cancer detection worldwide.`,

  wordPairs: {
    Detection: "진단",
    "in collaboration with": "협력하여",
  },

  questions: [],
};

const article7 = {
  id: 7,
  passage: `SolaraTech, a leading renewable energy company, has announced a $1 billion investment to expand its solar energy production facilities across North America. The initiative is part of the company's long-term strategy to accelerate the transition to clean energy and reduce carbon emissions.

The company plans to construct three large-scale solar farms in Texas, Arizona, and Nevada, aiming to increase total solar energy output by 40% over the next five years. CEO Laura Mitchell stated, "This investment reaffirms our commitment to sustainability and will provide clean, affordable energy to millions of homes."

Key Project Details:
• Investment Amount: $1 billion
• New Facilities: Texas, Arizona, Nevada
• Projected Completion: Late 2027

With government incentives and increasing corporate demand for renewable energy solutions, analysts expect SolaraTech's expansion to position it as a top competitor in the global clean energy market. The construction of the first facility is set to begin in early 2026.`,

  translation: `솔라라테크, 북미 전역 태양광 에너지 생산시설 확장을 위한 10억 달러 투자 발표
재생에너지 선도기업인 솔라라테크가 북미 전역의 태양광 에너지 생산시설 확장을 위해 10억 달러를 투자한다고 발표했습니다. 이 계획은 청정에너지로의 전환을 가속화하고 탄소배출을 줄이기 위한 기업의 장기 전략의 일환입니다.

이 기업은 텍사스, 애리조나, 네바다에 대규모 태양광 발전소 3곳을 건설할 계획이며, 향후 5년간 총 태양광 에너지 생산량을 40% 증가시키는 것을 목표로 하고 있습니다. 로라 미첼 CEO는 "이번 투자는 지속가능성에 대한 우리의 약속을 재확인하는 것이며, 수백만 가구에 청정하고 저렴한 에너지를 제공할 것"이라고 밝혔습니다.

주요 프로젝트 세부사항:
• 투자 금액: 10억 달러
• 신규 시설: 텍사스, 애리조나, 네바다
• 예상 완공: 2027년 말

정부 인센티브와 재생에너지 솔루션에 대한 기업 수요 증가로, 분석가들은 솔라라테크의 확장이 글로벌 청정에너지 시장에서 최고 경쟁자로서의 입지를 다질 것으로 예상합니다. 첫 번째 시설의 건설은 2026년 초에 시작될 예정입니다.`,

  koreanNouns: "",
  wordPairs: {},

  questions: [],
};

const article8 = {
  id: 8,
  passage: `Metro City has officially opened its highly anticipated high-speed rail line, connecting downtown with the suburban districts in record time. The new transit system is expected to reduce congestion, improve daily commutes, and support economic growth in surrounding areas.

Key Features of the New Rail Line:
• Travel Time Reduction: 40% faster than previous commuter trains
• Capacity: Up to 100,000 passengers daily
• Environmental Impact: Fully electric trains to cut carbon emissions

At the ribbon-cutting ceremony, Mayor James Carter highlighted the project's long-term benefits. "This rail line is more than just transportation—it's about creating opportunities, reducing travel time, and making Metro City more connected than ever before."

City officials estimate that the new system will increase public transit usage by 25% within the first year and stimulate local businesses near the newly developed stations. The government has also announced plans for further expansion, including additional express routes by 2028.`,

  translation: `메트로시티, 고대하던 고속철도 노선 공식 개통
메트로시티가 도심과 교외 지역을 최단 시간에 연결하는 고속철도 노선을 공식 개통했습니다. 이 새로운 교통 시스템은 교통 혼잡을 줄이고, 일상적인 통근을 개선하며, 주변 지역의 경제 성장을 지원할 것으로 예상됩니다.

새로운 철도 노선의 주요 특징:
• 이동 시간 단축: 기존 통근 열차보다 40% 빠름
• 수용 능력: 하루 최대 100,000명의 승객
• 환경 영향: 탄소 배출 감축을 위한 완전 전기 열차

개통식에서 제임스 카터 시장은 이 프로젝트의 장기적 이점을 강조했습니다. "이 철도 노선은 단순한 교통수단 이상입니다—이는 기회를 창출하고, 이동 시간을 줄이며, 메트로시티를 그 어느 때보다 더 연결되게 만드는 것입니다."

시 관계자들은 새로운 시스템이 첫 해 안에 대중교통 이용률을 25% 증가시키고 새로 개발된 역 주변의 지역 사업체들을 활성화할 것으로 예상합니다. 정부는 또한 2028년까지 추가 급행 노선을 포함한 추가 확장 계획을 발표했습니다.`,

  koreanNouns: `Metro City has officially opened its <mark>매우</mark> <mark>기대된</mark> high-speed <mark>철도 노선</mark>, connecting <mark>도심</mark> with the <mark>교외 지역</mark> in <mark>최단 시간</mark>. The new transit system is expected to reduce <mark>혼잡</mark>, improve daily <mark>통근</mark>, and support economic growth in surrounding areas.

Key Features of the New Rail Line:
• Travel Time <mark>단축</mark>: 40% faster than previous commuter trains
• Capacity: Up to 100,000 passengers daily
• Environmental Impact: <mark>완전</mark> electric trains to cut carbon emissions

At the ribbon-cutting ceremony, Mayor James Carter highlighted the project's long-term benefits. "This rail line is more than just transportation—it's about creating opportunities, reducing travel time, and making Metro City more connected than ever before."

<mark>시 관계자들</mark> estimate that the new system will increase <mark>대중교통 이용률</mark> <mark>안에</mark> the first year and stimulate local businesses near the <mark>새로</mark> developed stations. The government has also announced plans for further expansion, including additional <mark>급행 노선</mark> by 2028.`,

  wordPairs: {
    매우: "highly",
    기대된: "anticipated",
    "철도 노선": "rail line",
    도심: "downtown",
    "교외 지역": "suburban districts",
    "최단 시간": "record time",
    혼잡: "congestion",
    통근: "commutes",
    단축: "reduction",
    완전: "fully",
    "시 관계자들": "city officials",
    "대중교통 이용률": "public transit usage",
    안에: "within",
    새로: "newly",
    "급행 노선": "express routes",
  },

  questions: [],
};

const article9 = {
  id: 9,
  passage: `Tech Industry Faces Widespread Layoffs Amid Economic Slowdown

New York, March 15, 2025 – The global technology sector is experiencing a wave of layoffs as companies struggle to navigate an uncertain economic climate. In recent months, several major corporations, including Syntex Systems and VoltaTech, have announced significant reductions in their workforce, citing declining revenue and operational restructuring.

Industry analysts attribute these downsizing efforts to a combination of sluggish consumer demand, rising interest rates, and inflationary pressures, which have led to tighter corporate budgets. According to a report published by the National Bureau of Economic Analysis (NBEA), the tech industry has shed over 120,000 jobs in the first quarter of 2025 alone, a figure that surpasses last year's total layoffs in the sector.

Despite these cutbacks, some executives remain optimistic. Ethan Caldwell, CEO of Syntex Systems, emphasized that the company's restructuring is intended to "enhance efficiency and position the firm for long-term stability." Meanwhile, VoltaTech's chief financial officer, Samantha Reaves, stated that "while these layoffs are regrettable, they are necessary adjustments to ensure sustained growth in a volatile market."

Experts warn that further contractions could be imminent, particularly for firms reliant on venture capital funding, as investors adopt a more cautious approach. The U.S. Federal Reserve's continued tightening of monetary policy is expected to prolong financial constraints, making it difficult for companies to expand operations or retain staff.

Market analysts advise professionals in the sector to diversify their skill sets and explore opportunities in emerging fields such as artificial intelligence and cybersecurity, which continue to see strong demand despite the downturn.`,

  translation: `경제 침체 속 기술 산업계 전반적인 감원 직면

뉴욕, 2025년 3월 15일 – 글로벌 기술 산업계가 불확실한 경제 상황 속에서 어려움을 겪으며 대규모 감원을 진행하고 있습니다. 최근 몇 달간 신텍스 시스템즈와 볼타테크를 포함한 여러 대기업들이 수익 감소와 운영 구조조정을 이유로 상당한 규모의 인력 감축을 발표했습니다.

업계 분석가들은 이러한 구조조정이 둔화된 소비자 수요, 금리 인상, 인플레이션 압박이 복합적으로 작용하여 기업 예산이 축소된 결과라고 분석합니다. 국가경제분석국(NBEA)이 발표한 보고서에 따르면, 기술 산업계는 2025년 1분기에만 12만 개 이상의 일자리가 감소했으며, 이는 작년 한 해 전체 감원 규모를 넘어서는 수치입니다.

이러한 감축에도 불구하고 일부 경영진들은 낙관적인 입장을 유지하고 있습니다. 신텍스 시스템즈의 CEO 이단 콜드웰은 회사의 구조조정이 "효율성을 높이고 장기적인 안정성을 위한 포지셔닝"을 위한 것이라고 강조했습니다. 한편, 볼타테크의 최고재무책임자 사만다 리브스는 "이번 감원이 유감스럽지만, 변동성이 큰 시장에서 지속적인 성장을 보장하기 위해 필요한 조정"이라고 밝혔습니다.

전문가들은 투자자들이 더욱 신중한 접근을 취함에 따라 특히 벤처 캐피털 자금에 의존하는 기업들의 경우 추가 감축이 임박했을 수 있다고 경고합니다. 미 연방준비제도의 지속적인 통화정책 긴축으로 인해 금융 제약이 장기화될 것으로 예상되며, 이로 인해 기업들이 사업을 확장하거나 직원을 유지하기 어려워질 것으로 보입니다.

시장 분석가들은 이 분야의 전문가들에게 침체에도 불구하고 여전히 강한 수요를 보이는 인공지능과 사이버보안 같은 신흥 분야에서 기회를 모색하고 기술력을 다각화할 것을 조언하고 있습니다.`,

  koreanNouns: `Tech Industry <mark>직면하다</mark> Widespread <mark>정리해고</mark> <mark>속에서</mark> Economic <mark>침체</mark>

New York, March 15, 2025 – The global technology sector is experiencing <mark>물결</mark> layoffs as companies <mark>어려움을 겪다</mark> to navigate an <mark>불확실한</mark> economic <mark>상황</mark>. In recent months, <mark>여러</mark> major corporations, including Syntex Systems and VoltaTech, have announced significant reductions in their workforce, <mark>~을 이유로 들며</mark> declining revenue and <mark>운영 구조조정</mark>.

Industry analysts <mark>~ 때문이라고 보다</mark> these downsizing efforts to a combination of <mark>둔화된 소비자 수요</mark>, rising <mark>금리</mark>, and <mark>인플레이션 압박</mark>, which have led to <mark>긴축된</mark> corporate budgets. According to a report published by the National Bureau of Economic Analysis (NBEA), the tech industry has <mark>감축하다</mark> <mark>이상</mark> 120,000 jobs in the first quarter of 2025 alone, a <mark>수치</mark> that <mark>초과하다</mark> last year's total layoffs in the sector.

Despite these <mark>감축</mark>, some executives remain <mark>낙관적인</mark>. Ethan Caldwell, CEO of Syntex Systems, emphasized that the company's restructuring is intended to "enhance efficiency and position the firm for long-term <mark>안정성</mark>." <mark>한편</mark>, VoltaTech's <mark>최고재무책임자</mark>, Samantha Reaves, stated that "while these layoffs are <mark>유감스러운</mark>, they are <mark>필요한</mark> adjustments to ensure <mark>지속적인</mark> growth in a <mark>변동성이 큰 시장</mark>."

Experts warn that further <mark>감축</mark> could be <mark>임박한</mark>, particularly for firms <mark>의존하는</mark> on <mark>벤처캐피털 자금</mark>, as investors adopt a more <mark>신중한</mark> approach. The U.S. Federal Reserve's continued <mark>긴축</mark> of <mark>통화정책</mark> is expected to <mark>장기화하다</mark> <mark>금융 제약</mark>, making it difficult for companies to expand operations or retain staff.

Market analysts advise professionals in the sector to <mark>다각화하다</mark> their skill sets and explore opportunities in <mark>신흥 분야</mark> such as artificial intelligence and cybersecurity, which continue to <mark>보이다</mark> strong demand despite the <mark>침체</mark>.`,

  wordPairs: {
    직면하다: "faces",
    정리해고: "layoffs",
    속에서: "amid",
    침체: "slowdown",
    물결: "a wave of",
    "어려움을 겪다": "struggle",
    불확실한: "uncertain",
    상황: "climate",
    여러: "several",
    "~을 이유로 들며": "citing",
    "운영 구조조정": "operational restructuring",
    "~ 때문이라고 보다": "attribute",
    "둔화된 소비자 수요": "sluggish consumer demand",
    금리: "interest rates",
    "인플레이션 압박": "inflationary pressures",
    긴축된: "tighter",
    감축하다: "shed",
    이상: "over",
    수치: "figure",
    초과하다: "surpasses",
    감축: "cutbacks",
    낙관적인: "optimistic",
    안정성: "stability",
    한편: "meanwhile",
    최고재무책임자: "chief financial officer",
    유감스러운: "regrettable",
    필요한: "necessary",
    지속적인: "sustained",
    "변동성이 큰 시장": "volatile market",
    임박한: "imminent",
    의존하는: "reliant",
    "벤처캐피털 자금": "venture capital funding",
    신중한: "cautious",
    긴축: "tightening",
    통화정책: "monetary policy",
    장기화하다: "prolong",
    "금융 제약": "financial constraints",
    다각화하다: "diversify",
    "신흥 분야": "emerging fields",
    보이다: "see",
  },

  questions: [],
};

const article10 = {
  id: 10,
  passage: `After two years of construction, the Grand Central Library has officially opened its doors, offering a state-of-the-art facility for residents and students. The new library, located in the heart of downtown, features an extensive digital archive, modern study areas, and community event spaces.

During the opening ceremony, Mayor Daniel Collins highlighted the library's role in education and community engagement. "This is more than just a library—it's a space for learning, collaboration, and innovation," he stated.

The facility includes a children's reading section, multimedia labs, and free public Wi-Fi, making it a valuable resource for visitors of all ages. City officials anticipate that the Grand Central Library will serve over 500,000 visitors annually and become a central hub for cultural and academic activities in the region.`,

  translation: `2년간의 공사 끝에 그랜드 센트럴 도서관이 공식 개관하여 주민들과 학생들을 위한 최첨단 시설을 제공합니다. 도심부에 위치한 이 새로운 도서관은 광범위한 디지털 아카이브, 현대적인 학습 공간, 그리고 커뮤니티 행사 공간을 갖추고 있습니다.

개관식에서 대니얼 콜린스 시장은 교육과 지역사회 참여에서 도서관의 역할을 강조했습니다. "이곳은 단순한 도서관이 아닙니다—이는 학습, 협력, 그리고 혁신을 위한 공간입니다"라고 그는 말했습니다.

이 시설은 어린이 독서 구역, 멀티미디어 실험실, 무료 공공 와이파이를 포함하여 모든 연령대의 방문객들에게 가치 있는 자원이 될 것입니다. 시 관계자들은 그랜드 센트럴 도서관이 연간 50만 명 이상의 방문객들을 맞이하고 이 지역의 문화와 학술 활동의 중심지가 될 것으로 예상합니다.`,

  koreanNouns: "",
  wordPairs: {},

  questions: [],
};

const article11 = {
  id: 11,
  passage: `Metro City has officially opened the Westside Medical Center, a state-of-the-art healthcare facility designed to provide advanced medical services to residents. The new hospital, located in the growing western district, features a 24-hour emergency department, specialized treatment centers, and a research wing focused on medical innovation.

During the opening ceremony, Mayor James Reynolds emphasized the hospital's role in improving public health. "Access to high-quality healthcare is essential for a thriving community, and this facility ensures that all residents receive the medical care they need."

The medical center is expected to serve over 300,000 patients annually, offering advanced diagnostic technology and telemedicine services. City officials have also announced plans to expand preventive care programs and partnerships with local universities to support medical research initiatives.`,

  translation: `메트로시티, 웨스트사이드 메디컬 센터 공식 개원
메트로시티가 주민들에게 첨단 의료 서비스를 제공하기 위해 설계된 최첨단 의료 시설인 웨스트사이드 메디컬 센터를 공식 개원했습니다. 성장하는 서부 지역에 위치한 이 새로운 병원은 24시간 응급실, 전문 치료 센터, 의료 혁신에 중점을 둔 연구동을 갖추고 있습니다.

개원식에서 제임스 레이놀즈 시장은 공중 보건 개선에 있어 병원의 역할을 강조했습니다. "양질의 의료 서비스에 대한 접근성은 번영하는 지역사회에 필수적이며, 이 시설은 모든 주민들이 필요한 의료 서비스를 받을 수 있도록 보장합니다."

이 의료 센터는 연간 30만 명 이상의 환자들에게 서비스를 제공할 것으로 예상되며, 첨단 진단 기술과 원격 의료 서비스를 제공합니다. 시 관계자들은 또한 예방 의료 프로그램을 확대하고 의료 연구 계획을 지원하기 위해 지역 대학들과의 협력 관계를 구축할 계획을 발표했습니다.`,

  koreanNouns: `Metro City has officially opened the Westside Medical Center, a state-of-the-art healthcare facility designed to provide <mark>첨단</mark> medical services to residents. The new hospital, located in the growing western district, features a 24-hour emergency department, specialized treatment centers, and a <mark>연구동</mark> focused on medical innovation.

During the opening ceremony, <mark>시장</mark> James Reynolds emphasized the hospital's role in improving public health. "Access to high-quality healthcare is <mark>필수적</mark> for a <mark>번영하는 지역사회</mark>, and this facility ensures that all residents receive the medical care they need."

The medical center is expected to serve over 300,000 patients <mark>연간</mark>, offering advanced diagnostic technology and <mark>원격 의료</mark> services. <mark>시 관계자들</mark> have also announced plans to expand <mark>예방 의료 프로그램</mark> and partnerships with local universities to support medical research initiatives.`,
  wordPairs: {
    첨단: "advanced",
    연구동: "research wing",
    시장: "Mayor",
    필수적: "essential",
    "번영하는 지역사회": "thriving community",
    연간: "annually",
    "원격 의료": "telemedicine",
    "시 관계자들": "City officials",
    "예방 의료 프로그램": "preventive care programs",
  },

  questions: [],
};

const article12 = {
  id: 12,
  passage: `A prolonged drought across southern Africa is placing immense pressure on agricultural production, leading to record-low water reserves and widespread concerns about food security. According to the International Water Management Association (IWMA), rainfall levels in the region have declined by over 40% compared to historical averages, resulting in depleted reservoirs and failing irrigation systems.

Farmers in South Africa, Namibia, and Botswana have reported significant reductions in crop yields, particularly affecting staple foods such as maize and wheat. The shortage has also caused livestock losses, as many cattle ranchers struggle to maintain sufficient water supplies. The crisis has prompted regional governments to impose strict water rationing measures, prioritizing residential and emergency use over agricultural needs.

"This situation is rapidly escalating into a full-scale agricultural emergency," stated Dr. Evelyn Carter, a hydrology expert at the Global Climate Research Institute. "Without substantial intervention, including large-scale water conservation initiatives and alternative irrigation methods, the economic and social repercussions will be severe."

In response to the crisis, the African Development Fund (ADF) has pledged $200 million in emergency relief aid to assist affected farmers and develop long-term water management strategies. However, experts warn that these measures may take months to yield tangible results, leaving many communities vulnerable in the meantime.`,

  translation: `남부 아프리카의 장기화된 가뭄이 농업 생산에 막대한 압박을 가하고 있으며, 이로 인해 기록적인 수자원 부족과 식량 안보에 대한 광범위한 우려가 제기되고 있습니다. 국제 수자원 관리 협회(IWMA)에 따르면, 이 지역의 강수량이 과거 평균치에 비해 40% 이상 감소하여 저수지가 고갈되고 관개 시스템이 실패하고 있습니다.

남아프리카, 나미비아, 보츠와나의 농부들은 옥수수와 밀과 같은 주요 식량 작물에 특히 영향을 미치는 작물 수확량의 상당한 감소를 보고했습니다. 많은 축산 농가들이 충분한 물 공급을 유지하는 데 어려움을 겪으면서 가축 손실도 발생했습니다. 이 위기로 인해 지역 정부들은 농업용수보다 주거용 및 비상용수를 우선시하는 엄격한 물 배급 조치를 시행하게 되었습니다.

글로벌 기후 연구소의 수문학 전문가인 에블린 카터 박사는 "이 상황은 급속히 전면적인 농업 비상사태로 확대되고 있다"고 말했습니다. "대규모 물 절약 계획과 대체 관개 방법을 포함한 실질적인 개입이 없다면, 경제적, 사회적 파급 효과는 심각할 것입니다."

이 위기에 대응하여 아프리카 개발 기금(ADF)은 피해를 입은 농민들을 지원하고 장기적인 물 관리 전략을 개발하기 위해 2억 달러의 긴급 구호 자금을 약속했습니다. 그러나 전문가들은 이러한 조치들이 가시적인 결과를 내는 데 몇 달이 걸릴 수 있어 그 동안 많은 지역사회가 취약한 상태로 남게 될 것이라고 경고합니다.`,
  koreanNouns: "",
  wordPairs: {},

  questions: [],
};

const article13 = {
  id: 13,
  passage: `Grand Foods, one of the largest <mark>grocery retailers</mark> in the country, has finalized its <mark>acquisition</mark> of FreshHarvest Markets, a regional supermarket chain known for its focus on organic and locally sourced products. The $1.8 billion deal is expected to expand Grand Foods' presence in the organic food sector and enhance its supply chain efficiency.

With this <mark>acquisition</mark>, FreshHarvest's 120 store locations will be rebranded under the Grand Foods name while maintaining their commitment to fresh, sustainable products. "This merger allows us to bring high-quality, organic foods to more communities while streamlining our operations," said Grand Foods CEO Melissa Carter.

Industry experts suggest that the deal will enable Grand Foods to compete more effectively with national grocery chains like Whole Foods and Trader Joe's. The transition is set to begin in early 2026, with full <mark>integration</mark> expected by the end of the year.`,

  translation: `그랜드푸드, 프레시하베스트 마켓 인수 완료
국내 최대 식료품 소매업체 중 하나인 그랜드푸드가 유기농 및 지역 농산물에 중점을 둔 지역 슈퍼마켓 체인인 프레시하베스트 마켓의 인수를 완료했습니다. 18억 달러 규모의 이번 거래는 그랜드푸드의 유기농 식품 부문 입지를 확대하고 공급망 효율성을 향상시킬 것으로 예상됩니다.

이번 인수로 프레시하베스트의 120개 매장은 신선하고 지속 가능한 제품에 대한 약속을 유지하면서 그랜드푸드의 이름으로 리브랜딩될 예정입니다. 멜리사 카터 그랜드푸드 CEO는 "이번 합병을 통해 운영을 효율화하면서 더 많은 지역사회에 고품질 유기농 식품을 제공할 수 있게 되었다"고 말했습니다.

업계 전문가들은 이번 거래로 그랜드푸드가 홀푸드나 트레이더조스와 같은 전국 규모의 식료품 체인들과 더욱 효과적으로 경쟁할 수 있게 될 것이라고 제안합니다. 전환 작업은 2026년 초에 시작되어 연말까지 완전한 통합이 이루어질 것으로 예상됩니다.`,

  koreanNouns: `Grand Foods, one of the largest <mark>식료품 소매업체</mark> in the country, has finalized its <mark>인수</mark> of FreshHarvest Markets, a regional supermarket chain known for its focus on organic and locally sourced products. The $1.8 billion deal is expected to expand Grand Foods' presence in the organic food sector and enhance its supply chain efficiency.

With this <mark>인수</mark>, FreshHarvest's 120 store locations will be rebranded under the Grand Foods name while maintaining their commitment to fresh, sustainable products. "This merger allows us to bring high-quality, organic foods to more communities while streamlining our operations," said Grand Foods CEO Melissa Carter.

Industry experts suggest that the deal will enable Grand Foods to compete more effectively with national grocery chains like Whole Foods and Trader Joe's. The transition is set to begin in early 2026, with full <mark>통합</mark> expected by the end of the year.`,
  wordPairs: {
    "식료품 소매업체": "grocery retailers",
    인수: "acquisition",
    통합: "integration",
  },

  questions: [],
};

const article14 = {
  id: 14,
  passage: `GoldenBrew, a leading coffee brand, has launched its highly anticipated line of premium cold brew coffee, featuring all-natural ingredients and a smoother taste. The new product range includes three varieties: Classic Black, Vanilla Almond, and Mocha Hazelnut.

The company developed the line in response to growing consumer demand for high-quality, ready-to-drink coffee. Unlike traditional iced coffee, GoldenBrew's cold brew is <mark>steeped</mark> for 18 hours, resulting in a less acidic and naturally sweet flavor.

"Consumers today are looking for convenience without sacrificing quality," said Laura Mitchell, GoldenBrew's Chief Product Officer. "Our cold brew offers a rich, smooth taste with no artificial additives, making it the perfect choice for coffee lovers on the go."

The new cold brew line is now available in supermarkets and convenience stores <mark>nationwide</mark>, with plans to expand into international markets by early 2026.`,

  translation: `골든브루, 프리미엄 콜드브루 커피 라인 출시
선도적인 커피 브랜드인 골든브루가 천연 재료와 부드러운 맛을 특징으로 하는 기대가 높았던 프리미엄 콜드브루 커피 라인을 출시했습니다. 새로운 제품군은 클래식 블랙, 바닐라 아몬드, 모카 헤이즐넛 세 가지 종류를 포함합니다.

이 회사는 고품질의 바로 마실 수 있는 커피에 대한 증가하는 소비자 수요에 대응하여 이 라인을 개발했습니다. 전통적인 아이스 커피와 달리, 골든브루의 콜드브루는 18시간 동안 우려내어 산도가 낮고 자연스러운 단맛을 내는 결과를 얻었습니다.

로라 미첼 골든브루 최고제품책임자는 "오늘날의 소비자들은 품질을 희생하지 않으면서도 편의성을 찾고 있습니다"라고 말했습니다. "우리의 콜드브루는 인공 첨가물 없이 풍부하고 부드러운 맛을 제공하여, 바쁜 커피 애호가들에게 완벽한 선택이 될 것입니다."

새로운 콜드브루 라인은 현재 전국의 슈퍼마켓과 편의점에서 구매할 수 있으며, 2026년 초까지 국제 시장으로 확장할 계획입니다.`,

  koreanNouns: `GoldenBrew, a leading coffee brand, has launched its highly anticipated line of premium cold brew coffee, featuring all-natural ingredients and a smoother taste. The new product range includes three varieties: Classic Black, Vanilla Almond, and Mocha Hazelnut.

The company developed the line in response to growing consumer demand for high-quality, ready-to-drink coffee. Unlike traditional iced coffee, GoldenBrew's cold brew is <mark>우려내다</mark> for 18 hours, resulting in a less acidic and naturally sweet flavor.

"Consumers today are looking for convenience without sacrificing quality," said Laura Mitchell, GoldenBrew's Chief Product Officer. "Our cold brew offers a rich, smooth taste with no artificial additives, making it the perfect choice for coffee lovers on the go."

The new cold brew line is now available in supermarkets and convenience stores <mark>전국적으로</mark>, with plans to expand into international markets by early 2026.`,
  wordPairs: {
    우려내다: "steeped",
    전국적으로: "nationwide",
  },

  questions: [],
};

const article15 = {
  id: 15,
  passage: `The bestselling mystery novel The Forgotten City is set to hit the big screen, as Silverline Studios has officially announced its <mark>adaptation</mark> of the critically <mark>acclaimed</mark> book. The film, directed by award-winning filmmaker David Lin, is scheduled for release in late 2026.

The novel, written by Emma Caldwell, follows a journalist who uncovers a long-buried secret in a <mark>seemingly</mark> perfect town. Since its release in 2023, the book has sold over five million copies <mark>worldwide</mark> and has been translated into 12 languages.

"Bringing this story to life on screen is a dream come true," said Caldwell. "I can't wait to see how the characters and setting come alive in a cinematic format."

Filming is set to begin in early 2026, with casting decisions expected to be announced in the coming months. Industry experts predict that The Forgotten City could become one of the most highly anticipated literary adaptations of the decade.`,

  translation: `베스트셀러 미스터리 소설 '잊혀진 도시', 영화화 확정
실버라인 스튜디오가 호평받은 소설의 각색을 공식 발표하면서 베스트셀러 미스터리 소설 '잊혀진 도시'가 스크린에 오르게 됩니다. 수상 경력이 있는 영화감독 데이비드 린이 연출하는 이 영화는 2026년 말 개봉 예정입니다.

엠마 콜드웰이 쓴 이 소설은 겉보기에 완벽해 보이는 마을에서 오랫동안 묻혀있던 비밀을 밝혀내는 한 기자의 이야기를 다룹니다. 2023년 출간 이후 전 세계적으로 500만 부 이상 판매되었으며 12개 언어로 번역되었습니다.

콜드웰은 "이 이야기를 스크린에서 생명력을 갖게 하는 것은 꿈이 이루어진 것"이라고 말했습니다. "캐릭터들과 배경이 영화적 형식으로 어떻게 살아날지 정말 기대됩니다."

촬영은 2026년 초에 시작될 예정이며, 캐스팅 결정은 앞으로 몇 달 안에 발표될 것으로 예상됩니다. 업계 전문가들은 '잊혀진 도시'가 이번 10년간 가장 기대되는 문학 각색 작품 중 하나가 될 것으로 예측합니다.`,

  koreanNouns: `The bestselling mystery novel The Forgotten City is set to hit the big screen, as Silverline Studios has officially announced its <mark>각색</mark> of the critically <mark>호평받은</mark> book. The film, directed by award-winning filmmaker David Lin, is scheduled for release in late 2026.

The novel, written by Emma Caldwell, follows a journalist who uncovers a long-buried secret in a <mark>겉보기에</mark> perfect town. Since its release in 2023, the book has sold over five million copies <mark>전 세계적으로</mark> and has been translated into 12 languages.

"Bringing this story to life on screen is a dream come true," said Caldwell. "I can't wait to see how the characters and setting come alive in a cinematic format."

Filming is set to begin in early 2026, with casting decisions expected to be announced in the coming months. Industry experts predict that The Forgotten City could become one of the most highly anticipated literary adaptations of the decade.`,
  wordPairs: {
    adaptation: "각색",
    acclaimed: "호평받은",
    seemingly: "겉보기에",
    worldwide: "전 세계적으로",
  },

  questions: [],
};

const article16 = {
  id: 16,
  passage: `Metro City's largest cultural event, the Heritage & Arts Festival, will return next month, celebrating local traditions, music, and international cuisine. The annual event, now in its 15th year, is expected to attract more than 200,000 visitors.

📌 Festival Highlights:

Opening Parade: A grand procession featuring traditional dance performances
Food Pavilion: Over 50 vendors showcasing global cuisine
Art Exhibitions: Interactive displays by renowned and emerging artists
"This festival is a way for us to bring the community together and celebrate diversity," said Sarah Lin, Director of the Metro Cultural Foundation. "We've expanded the program this year to include more international performances and hands-on workshops."

The Heritage & Arts Festival will take place from October 15–20 at the Metro City Park and Cultural Center. Admission is free, with some special events requiring advance registration. City officials encourage attendees to use public transportation, as heavy traffic is expected around the venue.`,

  translation: `메트로시티 최대 문화 행사인 헤리티지 & 아츠 페스티벌이 다음 달에 돌아와 지역 전통, 음악, 세계 요리를 기념합니다. 15회를 맞이하는 이 연례 행사는 20만 명 이상의 방문객을 끌어들일 것으로 예상됩니다.

📌 축제 하이라이트:

개막 퍼레이드: 전통 무용 공연이 펼쳐지는 성대한 행진
음식 파빌리온: 세계 요리를 선보이는 50개 이상의 판매자
예술 전시회: 유명 및 신진 예술가들의 인터랙티브 전시

"이 축제는 지역사회를 하나로 모으고 다양성을 기념하는 방법입니다"라고 메트로 문화재단의 사라 린 이사는 말했습니다. "올해는 더 많은 국제 공연과 실습 워크숍을 포함하도록 프로그램을 확대했습니다."

헤리티지 & 아츠 페스티벌은 10월 15일부터 20일까지 메트로시티 공원 및 문화센터에서 열립니다. 입장은 무료이며, 일부 특별 행사는 사전 등록이 필요합니다. 행사장 주변에 심한 교통 체증이 예상되어 시 관계자들은 참가자들에게 대중교통 이용을 권장합니다.`,

  koreanNouns: `Metro City's largest cultural event, the Heritage & Arts Festival, will return next month, celebrating local traditions, music, and <mark>세계 요리</mark>. The <mark>연례</mark> event, now in its 15th year, is expected to attract more than 200,000 visitors.

📌 Festival Highlights:

Opening Parade: A grand <mark>행진</mark> featuring traditional dance performances
Food Pavilion: Over 50 <mark>판매자</mark> <mark>선보이는</mark> global cuisine
Art Exhibitions: Interactive displays by <mark>유명한</mark> and <mark>신진</mark> artists
"This festival is a way for us to bring the community together and celebrate <mark>다양성</mark>," said Sarah Lin, Director of the Metro Cultural Foundation. "We've expanded the program this year to include more international performances and hands-on workshops."

The Heritage & Arts Festival will take place from October 15–20 at the Metro City Park and Cultural Center. <mark>입장</mark> is free, with some special events requiring <mark>사전 등록</mark>. City officials encourage attendees to use public transportation, as heavy traffic is expected around the <mark>행사장</mark>.`,

  wordPairs: {
    "세계 요리": "international cuisine",
    연례: "annual",
    행진: "procession",
    판매자: "vendors",
    선보이는: "showcasing",
    유명한: "renowned",
    신진: "emerging",
    다양성: "diversity",
    입장: "admission",
    "사전 등록": "advance registration",
    행사장: "venue",
  },

  questions: [],
};

const article17 = {
  id: 17,
  passage: `Major City to Implement Congestion Pricing to Reduce Traffic
New York, September 18, 2025 – In an effort to combat worsening traffic congestion and air pollution, the city of New York has announced plans to introduce a congestion pricing system starting January 2026. Under the new policy, vehicles entering designated high-traffic zones during peak hours will be subject to a variable toll fee, with rates depending on the time of day and vehicle type.

City officials estimate that the initiative will reduce traffic volume by up to 20%, leading to shorter commute times and lower vehicle emissions. Mayor Daniel Reeves stated, "This system will not only improve mobility but also generate much-needed revenue for public transportation upgrades, including subway and bus system improvements."

While urban planners and environmental advocates have praised the move, some business owners and commuters have raised concerns. Local delivery companies argue that the fees will increase operational costs, which may be passed on to consumers. Others worry that the system will disproportionately affect lower-income drivers who rely on personal vehicles for work.

The city government has assured the public that discounted toll rates will be available for low-income residents and essential workers. Additionally, funds collected from congestion pricing will be allocated to modernizing transit infrastructure, expanding bike lanes, and improving pedestrian safety.

If successful, New York's model may serve as a blueprint for other major U.S. cities facing similar transportation challenges.`,

  translation: `대도시, 교통량 감소를 위한 혼잡통행료 제도 도입 예정
뉴욕, 2025년 9월 18일 – 악화되는 교통 혼잡과 대기오염 문제를 해결하기 위해, 뉴욕시는 2026년 1월부터 혼잡통행료 제도를 도입할 계획을 발표했습니다. 새로운 정책에 따르면, 혼잡 시간대에 지정된 고밀도 교통구역에 진입하는 차량들은 시간대와 차종에 따라 변동되는 통행료를 지불해야 합니다.

시 관계자들은 이 정책으로 교통량이 최대 20%까지 감소하여, 통근 시간이 단축되고 차량 배출가스가 줄어들 것으로 예상합니다. 대니얼 리브스 시장은 "이 제도는 이동성을 개선할 뿐만 아니라, 지하철과 버스 시스템 개선을 포함한 대중교통 업그레이드에 필요한 수익을 창출할 것"이라고 말했습니다.

도시계획가들과 환경운동가들이 이 정책을 환영하는 반면, 일부 사업주들과 통근자들은 우려를 제기했습니다. 지역 배달 업체들은 운영비가 증가하여 소비자에게 전가될 수 있다고 주장합니다. 또한 일부는 이 제도가 업무를 위해 개인 차량에 의존하는 저소득 운전자들에게 불균형적인 영향을 미칠 것을 우려합니다.

시 정부는 저소득 주민들과 필수 근로자들에게 할인된 통행료를 제공할 것이라고 대중을 안심시켰습니다. 또한, 혼잡통행료 수입은 대중교통 인프라 현대화, 자전거 도로 확장, 보행자 안전 개선에 배정될 예정입니다.

성공적으로 시행될 경우, 뉴욕의 모델은 비슷한 교통 문제에 직면한 다른 주요 미국 도시들의 청사진이 될 수 있을 것입니다.`,

  koreanNouns: `Major City to Implement <mark>혼잡통행료</mark> to Reduce Traffic
New York, September 18, 2025 – In an effort to <mark>대처하다</mark> worsening traffic congestion and air pollution, the city of New York has announced plans to introduce a <mark>혼잡통행료 제도</mark> starting January 2026. <mark>따라</mark> the new policy, vehicles entering designated high-traffic zones during peak hours will <mark>~에 따라 달라지다</mark> a <mark>변동</mark> toll fee, with rates depending on the time of day and vehicle type.

City officials estimate that the initiative will reduce traffic volume by up to 20%, leading to <mark>단축된</mark> commute times and <mark>감소된</mark> <mark>차량 배출가스</mark>. Mayor Daniel Reeves <mark>말했다</mark>, "This system will not only improve mobility but also generate <mark>필요한 수익</mark> for public transportation upgrades, including subway and bus system improvements."

While <mark>도시계획가</mark> and <mark>환경운동가</mark> have <mark>환영했다</mark> <mark>이 정책</mark>, some business owners and commuters have <mark>우려를 제기했다</mark>. Local delivery companies <mark>주장하다</mark> that the fees will increase operational costs, which may be <mark>전가되다</mark> to consumers. <mark>다른 이들은</mark> worry that the system will <mark>불균형적으로</mark> affect <mark>저소득</mark> drivers who rely on personal vehicles for work.

The city government has <mark>안심시켰다</mark> the public that discounted toll rates will be available for low-income residents and <mark>필수 직군 종사자</mark>. Additionally, funds collected from congestion pricing will be allocated to <mark>현대화하는</mark> transit infrastructure, expanding bike lanes, and improving pedestrian safety.

If successful, New York's model may serve as a <mark>청사진</mark> for other major U.S. cities facing similar <mark>교통 문제</mark>.`,

  wordPairs: {
    혼잡통행료: "congestion pricing",
    대처하다: "combat",
    "혼잡통행료 제도": "congestion pricing system",
    따라: "under",
    "~에 따라 달라지다": "be subject to",
    변동: "variable",
    단축된: "shorter",
    감소된: "lower",
    "차량 배출가스": "vehicle emissions",
    말했다: "stated",
    "필요한 수익": "much-needed revenue",
    도시계획가: "urban planners",
    환경운동가: "environmental advocates",
    환영했다: "praised",
    "이 정책": "the move",
    "우려를 제기했다": "raised concerns",
    주장하다: "argue",
    전가되다: "passed on",
    "다른 이들은": "others",
    불균형적으로: "disproportionately",
    저소득: "lower-income",
    안심시켰다: "assured",
    "필수 직군 종사자": "essential workers",
    현대화하는: "modernizing",
    청사진: "blueprint",
    "교통 문제": "transportation challenges",
  },

  questions: [],
};

const article18 = {
  id: 18,
  passage: `Entrepreneur Jane Whitmore Turns Local Coffee Shop into Global Brand
Source: Business Leaders Magazine
Date: November 3, 2025

By: Daniel Foster, Senior Business Correspondent

When Jane Whitmore opened a small coffee shop in Seattle ten years ago, she never imagined it would grow into Brew & Beyond, a global coffee chain with over 500 locations across 15 countries.

From a Single Café to an International Brand
Whitmore started her first café with a simple goal: to create a space where people could enjoy high-quality, <mark>ethically</mark> sourced coffee in a welcoming environment. Her unique approach—offering locally roasted beans and introducing a "slow brew" experience—quickly attracted a loyal customer <mark>base</mark>.

Challenges and Breakthroughs
"In the early days, I struggled to <mark>secure</mark> funding. Banks weren't convinced that a boutique coffee shop could compete with industry giants," Whitmore recalls. However, after partnering with a sustainable coffee farm in Colombia and securing a $1 million investment, Brew & Beyond expanded rapidly.

Future Growth
Now, Whitmore is focusing on eco-friendly initiatives, including <mark>compostable</mark> packaging and a <mark>carbon-neutral</mark> supply chain. She also plans to launch an online subscription service for customers who want freshly roasted coffee delivered to their homes.

"Success isn't just about numbers; it's about staying true to your values," she says. "If you focus on quality and innovation, growth will follow."`,

  translation: `기업가 제인 휘트모어, 지역 커피숍을 글로벌 브랜드로 성장시키다
출처: 비즈니스 리더스 매거진
날짜: 2025년 11월 3일

작성자: 다니엘 포스터, 수석 비즈니스 기자

제인 휘트모어가 10년 전 시애틀에 작은 커피숍을 열었을 때, 그녀는 그것이 15개국에 500개 이상의 매장을 가진 글로벌 커피 체인인 브루 & 비욘드로 성장할 것이라고는 상상도 하지 못했습니다.

단일 카페에서 국제 브랜드로
휘트모어는 사람들이 편안한 환경에서 고품질의 윤리적으로 조달된 커피를 즐길 수 있는 공간을 만든다는 단순한 목표로 첫 카페를 시작했습니다. 현지에서 로스팅한 원두를 제공하고 "슬로우 브루" 경험을 도입하는 그녀의 독특한 접근 방식은 빠르게 충성 고객층을 확보했습니다.

도전과 돌파구
"초기에는 자금 확보에 어려움을 겪었습니다. 은행들은 부티크 커피숍이 업계 거인들과 경쟁할 수 있다는 것을 확신하지 못했죠"라고 휘트모어는 회상합니다. 하지만 콜롬비아의 지속 가능한 커피 농장과 제휴하고 100만 달러의 투자를 확보한 후, 브루 & 비욘드는 급속히 확장되었습니다.

미래 성장
현재 휘트모어는 퇴비화 가능한 포장재와 탄소 중립 공급망을 포함한 친환경 계획에 집중하고 있습니다. 또한 갓 로스팅한 커피를 집으로 배달받기 원하는 고객들을 위한 온라인 구독 서비스도 출시할 계획입니다.

"성공은 단순히 숫자에 관한 것이 아닙니다. 자신의 가치관에 충실히 하는 것이죠"라고 그녀는 말합니다. "품질과 혁신에 집중하면 성장은 따라올 것입니다."`,
  koreanNouns: `Entrepreneur Jane Whitmore Turns Local Coffee Shop into Global Brand
Source: Business Leaders Magazine
Date: November 3, 2025

By: Daniel Foster, Senior Business Correspondent

When Jane Whitmore opened a small coffee shop in Seattle ten years ago, she never imagined it would grow into Brew & Beyond, a global coffee chain with over 500 locations across 15 countries.

From a Single Café to an International Brand
Whitmore started her first café with a simple goal: to create a space where people could enjoy high-quality, <mark>윤리적으로</mark> sourced coffee in a welcoming environment. Her unique approach—offering locally roasted beans and introducing a "slow brew" experience—quickly attracted a loyal customer <mark>기반</mark>.

Challenges and Breakthroughs
"In the early days, I struggled to <mark>확보하다</mark> funding. Banks weren't convinced that a boutique coffee shop could compete with industry giants," Whitmore recalls. However, after partnering with a sustainable coffee farm in Colombia and securing a $1 million investment, Brew & Beyond expanded rapidly.

Future Growth
Now, Whitmore is focusing on eco-friendly initiatives, including <mark>퇴비화 가능한</mark> packaging and a <mark>탄소 중립</mark> supply chain. She also plans to launch an online subscription service for customers who want freshly roasted coffee delivered to their homes.

"Success isn't just about numbers; it's about staying true to your values," she says. "If you focus on quality and innovation, growth will follow."`,
  wordPairs: {
    ethically: "윤리적으로",
    base: "기반",
    secure: "확보하다",
    "carbon-neutral": "탄소 중립",
    compostable: "퇴비화 가능한",
  },

  questions: [],
};

const article19 = {
  id: 19,
  passage: `Former Engineer Builds Billion-Dollar Tech Startup
Source: Innovators Weekly
Date: December 10, 2025

By: Lisa Carter, Senior Technology Reporter

Five years ago, Mark Reynolds was working as a software engineer at a mid-sized IT firm. Today, he is the CEO of CloudSync, a cloud-based security platform that has grown into a billion-dollar company serving clients in over 30 countries.

From Side Project to Startup Success
Reynolds initially developed CloudSync as a personal project, aiming to create a more efficient way to store and encrypt sensitive business data. What started as a small prototype soon attracted interest from investors, leading to a $5 million seed round in its first year.

Overcoming Challenges
"Building a startup was the hardest thing I've ever done," Reynolds admits. "There were months when we nearly ran out of funding. But our belief in the product kept us going." One of the biggest challenges was competing with established cloud service providers, but CloudSync's automated security monitoring and AI-driven threat detection set it apart.

What's Next?
CloudSync recently announced plans to expand into Asia and Europe while developing new AI-powered security features. Reynolds believes that staying ahead in the cybersecurity industry requires constant innovation and a willingness to take risks.

"Success isn't about avoiding failure—it's about learning from it and adapting quickly," he says.`,

  translation: `전직 엔지니어, 10억 달러 규모의 기술 스타트업 설립
출처: 이노베이터스 위클리
날짜: 2025년 12월 10일

작성자: 리사 카터, 수석 기술 기자

5년 전, 마크 레이놀즈는 중견 IT 기업의 소프트웨어 엔지니어로 일하고 있었습니다. 오늘날 그는 30개국 이상의 고객에게 서비스를 제공하는 10억 달러 규모의 기업으로 성장한 클라우드 기반 보안 플랫폼 클라우드싱크의 CEO입니다.

개인 프로젝트에서 스타트업 성공까지
레이놀즈는 처음에 민감한 비즈니스 데이터를 더 효율적으로 저장하고 암호화하는 방법을 만들기 위해 클라우드싱크를 개인 프로젝트로 개발했습니다. 작은 프로토타입으로 시작한 것이 곧 투자자들의 관심을 끌어 첫 해에 500만 달러의 시드 투자를 유치했습니다.

도전 극복하기
"스타트업을 설립하는 것은 제가 해본 것 중 가장 어려운 일이었습니다"라고 레이놀즈는 인정합니다. "자금이 거의 바닥날 뻔한 달들도 있었죠. 하지만 제품에 대한 우리의 믿음이 우리를 계속 나아가게 했습니다." 가장 큰 도전 중 하나는 기존 클라우드 서비스 제공업체들과 경쟁하는 것이었지만, 클라우드싱크의 자동화된 보안 모니터링과 AI 기반 위협 탐지가 차별화를 만들어냈습니다.

다음은 무엇인가?
클라우드싱크는 최근 새로운 AI 기반 보안 기능을 개발하면서 아시아와 유럽으로의 확장 계획을 발표했습니다. 레이놀즈는 사이버보안 업계에서 앞서 나가기 위해서는 지속적인 혁신과 위험을 감수하려는 의지가 필요하다고 믿습니다.

"성공은 실패를 피하는 것이 아니라 실패로부터 배우고 빠르게 적응하는 것입니다"라고 그는 말합니다.`,

  koreanNouns: "",
  wordPairs: {},

  questions: [],
};

const article20 = {
  id: 20,
  passage: `Rise of Subscription-Based Retail Alters Consumer Spending Habits

  San Francisco, November 3, 2025 – The retail landscape is <mark>undergoing</mark> a major transformation as subscription-based shopping models gain traction across a wide range of industries. Consumers are increasingly <mark>opting</mark> for monthly or annual subscription services for everything from groceries and clothing to personal care products and entertainment.

According to a report by the Global Consumer Insights Group, subscription-based retail sales have increased by 38% over the past two years, largely driven by younger <mark>demographics</mark> who prioritize convenience and personalized shopping experiences. Industry analysts attribute this shift to the appeal of predictable costs, exclusive member benefits, and automatic <mark>replenishment</mark> services, which eliminate the need for frequent store visits.

Major companies, including fashion retailers, meal-kit providers, and beauty brands, have capitalized on this trend by offering customized product deliveries tailored to individual preferences. LuxeStyle, a high-end fashion subscription company, reports that nearly 70% of its subscribers renew their memberships annually, citing curated selections and priority access to new collections as key factors.

Despite its popularity, the model is not without challenges. Some customers have raised concerns about subscription fatigue, as they struggle to manage multiple recurring payments. Others worry about limited flexibility, particularly when products do not meet expectations but are non-refundable. To address these issues, some companies have begun offering pause and cancellation options, allowing consumers greater control over their subscriptions.

Experts predict that while the subscription economy will continue to expand, retailers must balance <mark>exclusivity</mark> with flexibility to <mark>retain</mark> long-term customer loyalty.`,

  translation: `구독 기반 소매업이 소비자 지출 습관을 변화시키다
샌프란시스코, 2025년 11월 3일 – 구독 기반 쇼핑 모델이 다양한 산업 전반에 걸쳐 인기를 얻으면서 소매 시장이 큰 변화를 겪고 있습니다. 소비자들은 식료품, 의류에서부터 개인 관리 제품과 엔터테인먼트에 이르기까지 모든 것에 대해 월간 또는 연간 구독 서비스를 점점 더 선호하고 있습니다.

글로벌 소비자 인사이트 그룹의 보고서에 따르면, 구독 기반 소매 판매가 지난 2년간 38% 증가했으며, 이는 주로 편의성과 개인화된 쇼핑 경험을 중시하는 젊은 층에 의해 주도되었습니다. 업계 분석가들은 이러한 변화가 예측 가능한 비용, 독점적인 회원 혜택, 그리고 잦은 매장 방문의 필요성을 없애주는 자동 보충 서비스의 매력 때문이라고 분석합니다.

패션 소매업체, 밀키트 제공업체, 뷰티 브랜드를 포함한 주요 기업들은 개인의 선호도에 맞춘 맞춤형 제품 배송을 제공함으로써 이러한 트렌드를 활용해왔습니다. 고급 패션 구독 기업인 럭스스타일은 큐레이션된 선별 제품과 새로운 컬렉션에 대한 우선 접근권이 주요 요인이 되어 구독자의 약 70%가 매년 멤버십을 갱신한다고 보고했습니다.

인기에도 불구하고, 이 모델에는 과제가 없지 않습니다. 일부 고객들은 여러 반복 결제를 관리하는 데 어려움을 겪으면서 구독 피로감에 대한 우려를 제기했습니다. 다른 이들은 특히 제품이 기대에 미치지 못하지만 환불이 불가능한 경우 제한된 유연성에 대해 우려합니다. 이러한 문제를 해결하기 위해 일부 기업들은 소비자들에게 구독에 대한 더 큰 통제권을 제공하는 일시 중지 및 취소 옵션을 제공하기 시작했습니다.

전문가들은 구독 경제가 계속 확장될 것이지만, 소매업체들이 장기적인 고객 충성도를 유지하기 위해서는 배타성과 유연성 사이의 균형을 맞춰야 할 것이라고 예측합니다.`,

  koreanNouns: `Rise of Subscription-Based Retail Alters Consumer Spending Habits

  San Francisco, November 3, 2025 – The retail landscape is <mark>겪고 있다</mark> a major transformation as subscription-based shopping models gain traction across a wide range of industries. Consumers are increasingly <mark>선호한다</mark> for monthly or annual subscription services for everything from groceries and clothing to personal care products and entertainment.

According to a report by the Global Consumer Insights Group, subscription-based retail sales have increased by 38% over the past two years, largely driven by younger <mark>층</mark> who prioritize convenience and personalized shopping experiences. Industry analysts attribute this shift to the appeal of predictable costs, exclusive member benefits, and automatic <mark>보충</mark> services, which eliminate the need for frequent store visits.

Major companies, including fashion retailers, meal-kit providers, and beauty brands, have capitalized on this trend by offering customized product deliveries tailored to individual preferences. LuxeStyle, a high-end fashion subscription company, reports that nearly 70% of its subscribers renew their memberships annually, citing curated selections and priority access to new collections as key factors.

Despite its popularity, the model is not without challenges. Some customers have raised concerns about subscription fatigue, as they struggle to manage multiple recurring payments. Others worry about limited flexibility, particularly when products do not meet expectations but are non-refundable. To address these issues, some companies have begun offering pause and cancellation options, allowing consumers greater control over their subscriptions.

Experts predict that while the subscription economy will continue to expand, retailers must balance <mark>독점성</mark> with flexibility to <mark>유지하다</mark> long-term customer loyalty.`,
  wordPairs: {
    undergoing: "겪고 있다",
    opting: "선호한다",
    demographics: "층",
    replenishment: "보충",
    exclusivity: "독점성",
    retain: "유지하다",
  },

  questions: [],
};

const article21 = {
  id: 21,
  passage: `GlobalMart to Implement Cashier-Free Checkout System
December 12 – GlobalMart, one of the largest retail chains, has announced plans to introduce a cashier-free checkout system in select stores starting next year. 
This new system will allow customers to complete their purchases seamlessly using automated scanning and mobile payment options, reducing wait times and improving overall shopping convenience.

Shoppers will be able to scan items with their smartphones and pay instantly, eliminating the need for traditional checkout lines. 
Additionally, GlobalMart will install smart sensors and self-checkout kiosks to further enhance efficiency and minimize transaction times.

To assist customers in adapting to this change, the company will deploy in-store support staff and offer digital guides explaining the process. 
Frequent shoppers will also receive promotional discounts for using the new system during its initial rollout.

Retail analysts predict that this initiative will streamline operations and set a new standard for modernized shopping experiences. 
GlobalMart has indicated that, based on customer feedback, it may expand cashier-free technology to all locations nationwide.`,

  translation: `글로벌마트, 무인 계산대 시스템 도입 예정
12월 12일 – 최대 소매 체인 중 하나인 글로벌마트가 내년부터 일부 매장에서 무인 계산대 시스템을 도입할 계획을 발표했습니다. 이 새로운 시스템은 고객들이 자동화된 스캐닝과 모바일 결제 옵션을 사용하여 원활하게 구매를 완료할 수 있게 하여, 대기 시간을 줄이고 전반적인 쇼핑 편의성을 향상시킬 것입니다.

쇼핑객들은 스마트폰으로 상품을 스캔하고 즉시 결제할 수 있어, 전통적인 계산대 줄을 기다릴 필요가 없어집니다. 또한, 글로벌마트는 효율성을 더욱 높이고 거래 시간을 최소화하기 위해 스마트 센서와 셀프 계산대 키오스크를 설치할 예정입니다.

고객들이 이러한 변화에 적응할 수 있도록 회사는 매장 내 지원 직원을 배치하고 과정을 설명하는 디지털 가이드를 제공할 것입니다. 단골 고객들은 초기 출시 기간 동안 새로운 시스템을 사용할 경우 프로모션 할인도 받게 됩니다.

소매 분석가들은 이 이니셔티브가 운영을 간소화하고 현대화된 쇼핑 경험에 대한 새로운 기준을 설정할 것이라고 예측합니다. 글로벌마트는 고객 피드백을 바탕으로 무인 계산대 기술을 전국의 모든 지점으로 확대할 수 있다고 밝혔습니다.`,
  koreanNouns: `GlobalMart to Implement Cashier-Free Checkout System
December 12 – GlobalMart, one of the largest retail chains, has announced plans to introduce a cashier-free checkout system in select stores starting next year. 
This new system will allow customers to complete their purchases <mark>원활하게</mark> using automated scanning and mobile payment options, reducing wait times and improving overall shopping convenience.

Shoppers will be able to scan items with their smartphones and pay <mark>즉시</mark>, <mark>없애다</mark> the need for <mark>전통적인</mark> checkout lines. 
Additionally, GlobalMart will install smart sensors and self-checkout kiosks to further enhance efficiency and minimize <mark>거래</mark> times.

To assist customers in adapting to this change, the company will <mark>배치하다</mark> in-store support staff and offer digital guides explaining the process. 
Frequent shoppers will also receive promotional discounts for using the new system during its initial <mark>출시</mark>.

Retail analysts predict that this initiative will streamline operations and set a new standard for modernized shopping experiences. 
GlobalMart has indicated that, based on customer feedback, it may expand cashier-free technology to all locations <mark>전국적으로</mark>.`,

  wordPairs: {
    seamlessly: "원활하게",
    instantly: "즉시",
    eliminating: "없애다",
    traditional: "전통적인",
    transaction: "거래",
    deploy: "배치하다",
    rollout: "출시",
    nationwide: "전국적으로",
  },

  questions: [],
};
const article22 = {
  id: 22,
  passage: `Greenfield Launches Urban Tree Planting Program
By Rachel Monroe

The Greenfield City Council has introduced an ambitious initiative to expand urban green spaces and improve air quality. 
The program aims to plant thousands of trees across parks, sidewalks, and public areas over the next three years.

City officials have emphasized the importance of increasing tree coverage to <mark>counteract</mark> rising temperatures and reduce pollution levels. 
"More trees mean better air quality and lower energy costs for residents," said Mayor David Collins. He further explained that the city will provide <mark>subsidies</mark> for homeowners who plant trees on their properties, provided they maintain them for at least two years.

Rapid urban development has contributed to declining tree numbers, leading to increased heat retention and poorer air quality in densely <mark>populated</mark> areas. As a result, the city has allocated $12 million toward tree planting efforts, maintenance programs, and educational initiatives to encourage community participation.

Officials expect the first phase of planting to be completed by early next year, with continuous monitoring to ensure tree survival and long-term environmental benefits.`,

  translation: `그린필드, 도시 나무 심기 프로그램 시작
레이첼 먼로 기자

그린필드 시의회가 도시 녹지 공간을 확장하고 대기질을 개선하기 위한 야심찬 계획을 도입했습니다. 이 프로그램은 향후 3년 동안 공원, 보도 및 공공 장소 전역에 수천 그루의 나무를 심는 것을 목표로 합니다.

시 관계자들은 기온 상승을 억제하고 오염 수준을 줄이기 위해 나무 피복률을 높이는 것의 중요성을 강조했습니다. "더 많은 나무는 더 나은 대기질과 주민들의 에너지 비용 절감을 의미합니다"라고 데이비드 콜린스 시장이 말했습니다. 그는 또한 시에서 자신의 부지에 나무를 심는 주택 소유자들에게 보조금을 제공할 것이라고 설명했으며, 단 최소 2년 동안 나무를 관리해야 한다는 조건이 있습니다.

급속한 도시 개발로 인해 나무 수가 감소하여 인구 밀집 지역의 열 보존이 증가하고 대기질이 악화되었습니다. 이에 따라 시는 나무 심기 노력, 유지 관리 프로그램 및 지역사회 참여를 장려하기 위한 교육 이니셔티브에 1,200만 달러를 할당했습니다.

관계자들은 내년 초까지 첫 번째 식재 단계가 완료될 것으로 예상하며, 나무의 생존과 장기적인 환경 혜택을 보장하기 위해 지속적인 모니터링을 실시할 것입니다.`,
  koreanNouns: `Greenfield Launches Urban Tree Planting Program
By Rachel Monroe

The Greenfield City Council has introduced an ambitious initiative to expand urban green spaces and improve air quality. 
The program aims to plant thousands of trees across parks, sidewalks, and public areas over the next three years.

City officials have emphasized the importance of increasing tree coverage to <mark>상쇄하다</mark> rising temperatures and reduce pollution levels. 
"More trees mean better air quality and lower energy costs for residents," said Mayor David Collins. He further explained that the city will provide <mark>보조금</mark> for homeowners who plant trees on their properties, provided they maintain them for at least two years.

Rapid urban development has contributed to declining tree numbers, leading to increased heat retention and poorer air quality in densely <mark>인구 밀집된</mark> areas. As a result, the city has allocated $12 million toward tree planting efforts, maintenance programs, and educational initiatives to encourage community participation.

Officials expect the first phase of planting to be completed by early next year, with continuous monitoring to ensure tree survival and long-term environmental benefits.`,
  wordPairs: {
    counteract: "상쇄하다",
    subsidies: "보조금",
    populated: "인구 밀집된",
  },

  questions: [],
};

const article23 = {
  id: 23,
  passage: `Lakeside Introduces Comprehensive Flood Prevention Plan
By Thomas Reynolds

The Lakeside City Council has <mark>unveiled</mark> a large-scale flood prevention initiative aimed at protecting residents and businesses from <mark>recurring</mark> seasonal floods. The plan involves reinforcing existing drainage systems, constructing flood barriers, and upgrading critical infrastructure in high-risk areas.

"Flooding has become a growing concern in recent years, and we must take <mark>proactive</mark> steps to safeguard the community," said Mayor Angela Wright. She further explained that homeowners in <mark>designated</mark> flood zones will be eligible for financial assistance to install <mark>water-resistant</mark> features, such as raised foundations and improved drainage systems.

Unusually heavy rainfall and outdated infrastructure have led to severe flood damage in recent years. The cost of repairs has placed a significant financial burden on both the city and affected residents. To address these challenges, the city has committed $15 million to implement flood prevention <mark>measures</mark>, improve emergency response plans, and enhance public <mark>awareness</mark> about flood safety.

The initial phase of the project is expected to begin next month, with key improvements scheduled for completion within two years. <mark>Officials</mark> will closely monitor progress and make necessary adjustments to ensure long-term effectiveness.`,

  translation: `레이크사이드, 종합적인 홍수 예방 계획 도입
토마스 레이놀즈 기자

레이크사이드 시의회가 주민과 기업을 반복되는 계절성 홍수로부터 보호하기 위한 대규모 홍수 예방 이니셔티브를 공개했습니다. 이 계획은 기존 배수 시스템 강화, 홍수 방벽 건설, 고위험 지역의 중요 인프라 업그레이드를 포함합니다.

"홍수는 최근 몇 년간 증가하는 우려사항이 되었으며, 우리는 지역사회를 보호하기 위해 사전 예방적 조치를 취해야 합니다"라고 안젤라 라이트 시장이 말했습니다. 그녀는 또한 지정된 홍수 구역의 주택 소유자들이 높아진 기초와 개선된 배수 시스템과 같은 내수성 기능을 설치하기 위한 재정 지원을 받을 자격이 있다고 설명했습니다.

비정상적으로 많은 강우량과 노후화된 인프라로 인해 최근 몇 년간 심각한 홍수 피해가 발생했습니다. 수리 비용은 시와 피해를 입은 주민 모두에게 상당한 재정적 부담을 안겼습니다. 이러한 과제를 해결하기 위해 시는 홍수 예방 조치 시행, 비상 대응 계획 개선, 홍수 안전에 대한 대중 인식 향상을 위해 1,500만 달러를 투입하기로 약속했습니다.

프로젝트의 초기 단계는 다음 달에 시작될 예정이며, 주요 개선 사항은 2년 내에 완료될 예정입니다. 관계자들은 진행 상황을 면밀히 모니터링하고 장기적인 효과를 보장하기 위해 필요한 조정을 할 것입니다.`,
  koreanNouns: `Lakeside Introduces Comprehensive Flood Prevention Plan
By Thomas Reynolds

The Lakeside City Council has <mark>공개했다.</mark> a large-scale flood prevention initiative aimed at protecting residents and businesses from <mark>반복되는</mark> seasonal floods. The plan involves reinforcing existing drainage systems, constructing flood barriers, and upgrading critical infrastructure in high-risk areas.

"Flooding has become a growing concern in recent years, and we must take <mark>미리 대응하는</mark> steps to safeguard the community," said Mayor Angela Wright. She further explained that homeowners in <mark>지정된</mark> flood zones will be eligible for financial assistance to install <mark>내수성</mark> features, such as raised foundations and improved drainage systems.

Unusually heavy rainfall and outdated infrastructure have led to severe flood damage in recent years. The cost of repairs has placed a significant financial burden on both the city and affected residents. To address these challenges, the city has committed $15 million to implement flood prevention <mark>조치</mark>, improve emergency response plans, and enhance public <mark>인식</mark> about flood safety.

The initial phase of the project is expected to begin next month, with key improvements scheduled for completion within two years. <mark>관계자들</mark> will closely monitor progress and make necessary adjustments to ensure long-term effectiveness.`,
  wordPairs: {
    unveiled: "공개했다.",
    recurring: "반복되는",
    proactive: "미리 대응하는",
    designated: "지정된",
    "water-resistant": "내수성",
    measures: "조치",
    awareness: "인식",
    Officials: "관계자들",
  },

  questions: [],
};

export const articleQuestions = [
  article1,
  article2,
  article3,
  article4,

  article7,
  article8,
  article9,
  article10,
  article11,
  article12,
  article13,
  article14,
  article15,
  article16,
  article17,
  article18,
  article19,
  article20,
  article21,
  article22,
  article23,
];
